import { Component, OnInit, NgModule } from '@angular/core';
import { DominioService } from '../../_services/dominio.service';
import { TituloService } from '../../_services/titulo.service';
import {AppBreadcrumbService} from '../../app.breadcrumb.service';

import { StatusBoleto } from '../../_models/dominio/statusBoleto';
import { StatusEmail } from '../../_models/dominio/statusEmail';
import { TipoCedente } from '../../_models/dominio/tipoCedente';
import { TipoInscricao } from '../../_models/dominio/tipoInscricao';
import { TipoRegistroTitulo } from '../../_models/dominio/tipoRegistroTitulo';
import { TipoMoeda } from '../../_models/dominio/tipoMoeda';
import { Titulo } from 'src/app/_models/titulo/titulo';
import { FilterTitulo } from 'src/app/_models/filter/filterTitulo';
import { FilterCedente } from 'src/app/_models/filter/filterCedente';
import { FilterSacado } from 'src/app/_models/filter/FilterSacado';
import { EmailSacado } from 'src/app/_models/titulo/emailSacado';
import { EmailSacadoService } from 'src/app/_services/emailSacado.service';
import { MessageService, Message, LazyLoadEvent } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { CurrencyPipe } from '@angular/common';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { Image } from 'src/app/demo/domain/image';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';
import { PageDTO } from 'src/app/_models/titulo/pageDTO';
import { BancoService } from 'src/app/_services/banco.service';
import { Banco } from 'src/app/_models/banco/banco';
import { Carteira } from 'src/app/_models/carteira/carteira';
import { YesNo } from 'src/app/_models/dominio/YesNo';
import { ListaPagamentoDTO } from 'src/app/_models/titulo/ListaPagamentoDTO';
import { EstadoService } from 'src/app/_services/estado.service';
import { Estado } from 'src/app/_models/dominio/estado';


@Component({
    templateUrl: 'pesquisatitulo.component.html',
    styleUrls: ['pesquisatitulo.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, DatePipe, CurrencyPipe]
})

export class PesquisaTituloComponent implements OnInit {

    msgs: Message[] = [];

    statusBoletoArr: any = [];
    tipoCedenteArr: any = [];
    tipoMoedaArr: any = [];
    tipoRegistroTituloArr: any = [];
    codNossoNumeroArr: [];

    filter: FilterTitulo = {};
    filterCedente: FilterCedente = {};
    filterSacado: FilterSacado = {};

    titulos: Titulo[];
    titulosExport: Titulo[];
    selectedTitulos: Titulo[];
    cols: any[];
    header: any[];

    statusBoleto: StatusBoleto = null;
    statusBoletoId: number = null;
    statusEmail: StatusEmail = null;
    tipoCedente: TipoCedente = null;
    tipoInscricao: TipoInscricao = null;
    tipoMoeda: TipoMoeda = null;
    tipoRegistroTitulo: TipoRegistroTitulo = null;
    nossoNumero: string = null;
    documentoSacado: string = null;
    documentoCedente: string = null;
    dtaVencimentoInicial: Date = null;
    dtaVencimentoFinal: Date = null;
    dtaLiquidacaoInicial: Date = null;
    dtaLiquidacaoFinal: Date = null;
    estado: Estado = null;

    tituloDialog: boolean;
    emailDialog: boolean;
    sendEmailInput: string;
    submitted: boolean;
    titulo: Titulo;
    emailSacado: EmailSacado;
    emailSacadoReturn: EmailSacado;

     msgError: string;

     pt: {};

    filteredStatusBoleto: StatusBoleto[];
    selectedStatusBoletoAdvanced: StatusBoleto[];
    statusBoletoSel?: StatusBoleto;

    sacadoDialog: boolean;
    image: Image;
    url: SafeUrl;

    perfil: Perfil;
    currentUsuario: Usuario;
    pesquisarTituloLabel: string;
    mensagem101: string;

    rangeDates: Date[];

    minDateVencimento: Date;
    maxDateVencimento: Date;

    pesquisando: boolean;
    pesquisandoProgress: boolean;
    count: number;
    tituloPdf: Titulo;
    tituloDetalhe: boolean;
    totalRecords: number;
    pageDto: PageDTO;
    loading: boolean;
    fired: boolean;

    bancosArr: Banco[] = [];
    filteredBanco: Banco[] = [];
    bancoSel?: Banco;

    estadosArr: Estado[] = [];
    filteredEstado: Estado[] = [];
    estadoSel?: Estado = {uf: undefined};

    tipoInscricaoArr: any = [];
    filteredTipoInscricao: TipoInscricao[] = [];
    tipoInscricaoSel?: TipoInscricao = {desTipoInscricao: undefined};

    carteiraArr: any = [];
    filteredCarteira: Carteira[];
    carteiraSel?: Carteira;

    envioPrimeiraVia: YesNo[];

    totalPagamentosSelecionados = 0;
    selecaoPdF: string;
    msgErrorBoolean = false;
    selectedPagamentos: Titulo[] = new Array();
    listaPagamentoDTO: ListaPagamentoDTO;
    bottomSidebarImpressaoComprovantes;
    exibirCheckBoxAprovacao: boolean = false;
    valorAprovacao = 0;
    bottomSidebar;

    constructor(private dominioService: DominioService, private breadcrumbService: AppBreadcrumbService,
                private tituloService: TituloService, private emailSacadoService: EmailSacadoService,
                private messageService: MessageService, private datepipe: DatePipe, private currencyPipe: CurrencyPipe,
                private sanitizer: DomSanitizer, private authenticationService: AuthenticationService,
                private bscobrancaTranslate: BscobrancaTranslate, private bancoService: BancoService,
                private estadoService: EstadoService) {
        this.pesquisarTituloLabel = this.bscobrancaTranslate.getText('menu.pesquisaTitulo');
        this.breadcrumbService.setItems([
            { label: this.pesquisarTituloLabel, routerLink: ['/titulo/pesquisatitulo'] }
        ]);
        this.cols = [
            { field: 'statusBoleto.desStatusBoleto', header: 'Banco' },
            { field: 'cedente', header: 'Cedente' },
            { field: 'sacado.nmeSacado', header: 'Sacado' },
            { field: 'codNossoNumero', header: 'Nosso Numero' },
            { field: 'dtaVencimento', header: 'Dta. Vencimento' },
            { field: 'vlrTitulo', header: 'Valor' },
            { field: 'dtaVencimento', header: 'Dta. Liquidacao' },
            { field: 'dtaPagamento', header: 'Dta. Criacao' },
            { field: 'statusBoleto.desStatusBoleto', header: 'Status' },
            { field: '', header: 'Acao' },
        ];

        this.envioPrimeiraVia = [
            {name: this.bscobrancaTranslate.getText('titulo.sim'), code: 'SIM'},
            {name: this.bscobrancaTranslate.getText('titulo.nao'), code: 'NAO'},
        ];

        this.header = ['Banco', 'Cedente', 'Sacado', 'Nosso Numero', 'Dta. Vencimento', 'Valor', 'Dta. Liquidacao', 'Dt. Pagamento' , 'Status', 'Cod. Rejeicao', 'Des. Rejeicao'];
        this.loading = false;
    }

    changeDate() {
        let date: Date;
        date = this.rangeDates[0];
        this.minDateVencimento = date;
        this.maxDateVencimento = new Date(this.minDateVencimento);
        this.maxDateVencimento.setDate(this.minDateVencimento.getDate() + 90);
    }

    ngOnInit(): void {
        this.exibirCheckBoxAprovacao = true;
        this.currentUsuario = this.authenticationService.atualUserValue;
        this.perfil = this.authenticationService.atualUserPerfilValue;
        this.dominioService.getAllStatusBoleto().subscribe(status => {
            this.statusBoletoArr = Array.from(status);
            this.statusBoletoArr = this.statusBoletoArr.filter((e) => {
                if(e.staMostra !== 'N') {
                    return e;
                }
            })
        });
        this.dominioService.getAllTipoCedente().subscribe(cedentes => {
            this.tipoCedenteArr = Array.from(cedentes);
        });
        this.dominioService.getAllTipoInscricao().subscribe(inscricoes => {
            this.tipoInscricaoArr = Array.from(inscricoes);
        });
        this.dominioService.getAllTipoMoeda().subscribe(moedas => {
            this.tipoMoedaArr = Array.of(moedas);
        });

        this.bancoService.getAllBancoTodos().subscribe(bancos => {
            this.bancosArr = bancos
            this.bancosArr = this.bancosArr.filter((e) => {
                if(e.situacao === 'ATIVO') {
                    return e;
                }
            })
        });

        this.estadoService.getAllEstadoTodos().subscribe(estados => {
            this.estadosArr = Array.from(estados);
        });

        this.filter.banco = {};

        this.pt = {
            firstDayOfWeek: 0,
            dayNames: ['Domingo', 'Segunda', 'Ter?a', 'Quarta', 'Quinta', 'Sexta', 'S?bado'],
            dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
            monthNames: ['Janeiro', 'Fevereiro', 'Mar?o', 'Abril', 'Maio', 'Junho', 'Julho',
                'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            today: 'Hoje',
            clear: 'Limpar'
            };
    }

    viewBoleto(titulo: Titulo) {
    this.emailSacadoService.getImageTitulo(titulo.codTitulo).subscribe((data) => {
        const file = new Blob([data], {type: 'image/png'});
        console.log(file);
        const urlCreator = window.URL;
        this.url = this.sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(new Blob([data], {type: 'image/png'})));
        console.log(this.url);
        this.sacadoDialog = true;
    });
    this.tituloPdf = titulo;
   }

   hideDialogSacadoDialog() {
    this.sacadoDialog = false;
    }

    detalhesTitulo(titulo: Titulo) {
      this.titulo = titulo;
      this.tituloDetalhe = true;
    }

    hideDetalhesTituloDialog() {
     this.tituloDetalhe = false;
    }



downloadPdf() {
        this.emailSacadoService.getPdfTitulo(this.tituloPdf.codTitulo).subscribe((res) => {
            const blob = new Blob([res], { type: 'application/pdf' });
            const dwldLink = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
            if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
                dwldLink.setAttribute('target', '_blank');
            }
            dwldLink.setAttribute('href', url);
            dwldLink.setAttribute('download', this.tituloPdf.sacado.nmeSacado + '.pdf');
            dwldLink.style.visibility = 'hidden';
            document.body.appendChild(dwldLink);
            dwldLink.click();
            document.body.removeChild(dwldLink);
        });
    }

    printComponent(cmpName) {
        const printContent = document.getElementById(cmpName);
        const WindowPrt = window.open('', '', 'left=0,top=50,width=980,height=900,toolbar=0,scrollbars=0,status=0');
        WindowPrt.document.write('<html style="height: auto><head><title>T?tulo</title>');
        WindowPrt.document.write('<style> .print+.print {');
        WindowPrt.document.write('page-break-before: always;');
        WindowPrt.document.write('}');
        WindowPrt.document.write('</style></head><body style="height: auto">');
        WindowPrt.document.write(printContent.innerHTML);
        WindowPrt.document.write('</body></html>');
        WindowPrt.document.close();
        WindowPrt.focus();
        WindowPrt.print();
        WindowPrt.close();
    }

    pesquisarTituloPage(): void {
        this.fecharBottomSidebarImpressaoComprovantes()
        if (this.perfil.nmePerfil === 'ADMTIVIT' || this.perfil.nmePerfil === 'MNGTIVIT' || this.perfil.nmePerfil === 'OPRTIVIT') {
            this.filter.cedente = this.filterCedente;
        } else {
            this.filter.cedente = {};
            this.filter.cedente.codInscricao = this.currentUsuario.empresa.nroCNPJ;
        }
        this.filter.sacado = this.filterSacado;
        this.filter.statusBoleto = this.statusBoletoSel;
        this.filter.banco = this.bancoSel;
        this.filter.carteira = this.carteiraSel;

        this.filter.sacado.desTipoInscricao = this.tipoInscricaoSel.desTipoInscricao;
        this.tipoInscricao = this.tipoInscricaoSel;

        this.filter.sacado.codUfSacado = this.estadoSel.uf;
        this.estado = this.estadoSel;

        this.msgs = [];
        this.msgError = this.validarpesquisarTitulo();
        if (this.msgError === '') {
            this.loading = true;
            this.fired = true;
            this.filter.pageIndex = 0;
            this.filter.pageSize = 10;
            this.tituloService.pesquisarTituloPageable(this.filter)
            .subscribe(
                result => {
                    this.pageDto = result;
                    this.titulos = this.pageDto.elements;
                    this.totalRecords = this.pageDto.totalElements;
                    this.loading = false;
                } ,
                err => console.log(err),
                () => {
                    this.pesquisandoProgress = false;
                    this.pesquisando = false;
                }
            );
            this.pesquisando = false;
        } else {
            this.pesquisando = false;
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Erro:', detail: this.msgError });
        }
    }

    nextPage(event: LazyLoadEvent) {
        if (this.fired) {
            this.loading = true;
            this.filter.pageIndex = event.first / 10;
            this.filter.pageSize = event.rows;
            this.filter.sortField = event.sortField || '';
            this.filter.sortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
            this.tituloService.pesquisarTituloPageable(this.filter)
            .subscribe(
                result => {
                    this.pageDto = result;
                    this.titulos = this.pageDto.elements;
                    this.totalRecords = this.pageDto.totalElements;
                    this.loading = false;
                } ,
                err => console.log(err),
                () => {
                this.pesquisandoProgress = false;
                this.pesquisando = false;
            });
            this.pesquisando = false;
        }
    }



    validarpesquisarTitulo() {
        if (this.perfil.nmePerfil === 'ADMTIVIT' || this.perfil.nmePerfil === 'MNGTIVIT' || this.perfil.nmePerfil === 'OPRTIVIT') {
            if (!this.filter.cedente.codInscricao && !this.filter.codNossoNumero && !this.filter.sacado.documento
                && !this.filter.dtaVencimentoInicial && !this.filter.dtaVencimentoFinal
                && !this.filter.dtaLiquidacaoInicial && !this.filter.dtaLiquidacaoFinal && this.filter.statusBoleto === undefined
                && !this.filter.sacado.seuNumero && !this.bancoSel && !this.filter.convenio
                && !this.filterCedente.nmeCedente && !this.filterSacado.nmeSacado && !this.filterSacado.nmeBairroSacado
                && !this.filterSacado.nmeEnderecoSacado && this.tipoInscricaoSel.desTipoInscricao === undefined
                && this.estadoSel.uf === undefined && !this.filterSacado.dscEmail) {
                return this.bscobrancaTranslate.getText('mensagens.titulo-001');
            }
        } else {
            if (!this.filter.codNossoNumero && !this.filter.sacado.documento
                && !this.filter.dtaVencimentoInicial && !this.filter.dtaVencimentoFinal
                && !this.filter.dtaLiquidacaoInicial && !this.filter.dtaLiquidacaoFinal && this.filter.statusBoleto === undefined
                && !this.filter.sacado.seuNumero && !this.bancoSel && !this.filter.convenio
                && !this.filterCedente.nmeCedente && !this.filterSacado.nmeSacado && !this.filterSacado.nmeBairroSacado
                && !this.filterSacado.nmeEnderecoSacado && this.tipoInscricaoSel.desTipoInscricao === undefined
                && this.estadoSel.uf === undefined && !this.filterSacado.dscEmail) {
                    return this.bscobrancaTranslate.getText('mensagens.titulo-001');
            }
        }
        if (!this.filter.cedente.codInscricao && !this.filter.codNossoNumero && !this.filter.sacado.documento
            && !this.filter.dtaVencimentoInicial && !this.filter.dtaVencimentoFinal
            && !this.filter.dtaLiquidacaoInicial && !this.filter.dtaLiquidacaoFinal && this.filter.statusBoleto === undefined
            && !this.filter.sacado.seuNumero && !this.bancoSel && !this.filter.convenio
            && !this.filterCedente.nmeCedente && !this.filterSacado.nmeSacado && !this.filterSacado.nmeBairroSacado
            && !this.filterSacado.nmeEnderecoSacado && this.tipoInscricaoSel.desTipoInscricao === undefined
            && this.estadoSel.uf === undefined && !this.filterSacado.dscEmail) {
            return this.bscobrancaTranslate.getText('mensagens.titulo-001');
        }

        if (this.filter.dtaVencimentoInicial && this.filter.dtaVencimentoFinal) {
            let retorno = this.compareDate(this.filter.dtaVencimentoInicial, this.filter.dtaVencimentoFinal);
            if (retorno === 1) {
                return this.bscobrancaTranslate.getText('mensagens.titulo-002');
            }
            retorno = this.compareDate(this.filter.dtaVencimentoFinal, this.filter.dtaVencimentoInicial);
            if (retorno === -1) {
                return this.bscobrancaTranslate.getText('mensagens.titulo-003');
            }
        }

        if (this.filter.dtaLiquidacaoInicial && this.filter.dtaLiquidacaoFinal) {
            let retorno = this.compareDate(this.filter.dtaLiquidacaoInicial, this.filter.dtaLiquidacaoFinal);
            if (retorno === 1) {
                 return this.bscobrancaTranslate.getText('mensagens.titulo-004');
            }
            retorno = this.compareDate(this.filter.dtaLiquidacaoFinal, this.filter.dtaLiquidacaoInicial);
            if (retorno === -1) {
                return this.bscobrancaTranslate.getText('mensagens.titulo-005');
            }
        }
        return '';
    }

    limparFormulario(): void {
        this.titulos = null;
        this.selectedTitulos = null;
        this.msgs = [];

        this.filter = {};
        this.filterCedente = {};
        this.filterSacado = {};

        this.nossoNumero = null;
        this.documentoSacado = null;
        this.documentoCedente = null;
        this.dtaVencimentoInicial = null;
        this.dtaVencimentoFinal = null;
        this.dtaLiquidacaoInicial = null;
        this.dtaLiquidacaoFinal = null;

        this.statusBoletoId = null;
        this.fired = false;


        this.filteredStatusBoleto = [];
        this.filteredBanco = [];
        this.filteredTipoInscricao = [];
        this.filteredEstado = [];

        this.selectedStatusBoletoAdvanced = [];

        this.statusBoletoSel = {};
        this.bancoSel = {};
        this.estadoSel = {};
        this.tipoInscricaoSel = {};

        this.filter.convenio = '';

        this.dominioService.getAllStatusBoleto().subscribe(status => {
            this.statusBoletoArr = Array.from(status);
            this.statusBoletoArr = this.statusBoletoArr.filter((e) => {
                if(e.staMostra !== 'N') {
                    return e;
                }
            })
        });
        this.dominioService.getAllTipoCedente().subscribe(cedentes => {
            this.tipoCedenteArr = Array.from(cedentes);
        });
        this.dominioService.getAllTipoInscricao().subscribe(inscricoes => {
            this.tipoInscricaoArr = Array.from(inscricoes);
        });
        this.dominioService.getAllTipoMoeda().subscribe(moedas => {
            this.tipoMoedaArr = Array.of(moedas);
        });

        this.bancoService.getAllBancoTodos().subscribe(bancos => {
             this.bancosArr = bancos
             this.bancosArr = this.bancosArr.filter((e) => {
                if(e.situacao === 'ATIVO') {
                    return e;
                }
            })
        });

        this.estadoService.getAllEstadoTodos().subscribe(estados => {
            this.estadosArr = Array.from(estados);
        });

        this.selectedPagamentos = [];
        this.exibirCheckBoxAprovacao = true;
        this.fecharBottomSidebarImpressaoComprovantes();
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.statusBoletoArr.length; i++) {
            if (this.statusBoletoArr[i].codStatusBoleto === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    numberOnly(event: { which: any; keyCode: any; }): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    hideDialog() {
        this.tituloDialog = false;
        this.emailDialog = false;
        this.submitted = false;
    }

    sendEmail(titulo: Titulo) {
        this.messageService.clear();
        this.emailSacadoReturn = {};
        this.emailSacado.codSacado = titulo.sacado.codSacado;
        this.emailSacado.codTitulo = titulo.codTitulo;
        this.emailSacado.codCedente = titulo.cedente.codCedente;
        this.emailSacadoService.sendEmail(this.emailSacado).subscribe(
                response => this.emailSacadoReturn = response,
                err => console.log(err));
        this.tituloDialog = false;
        this.submitted = false;
        this.messageService.add({severity: 'success', summary: 'Successful', detail: this.bscobrancaTranslate.getText('mensagens.titulo-006'), life: 3000});
    }

    sendEditBanco(titulo: Titulo) {
        this.titulo = titulo;
        this.emailSacado = {};
        this.submitted = false;
        this.tituloDialog = true;
    }

    filterStatusBoleto(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.statusBoletoArr.length; i++) {
            const status = this.statusBoletoArr[i];
            if (status.desStatusBoleto.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(status);
            }
        }
        this.filteredStatusBoleto = filtered;
    }

    filterBanco(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.bancosArr.length; i++) {
            let banco: Banco = this.bancosArr[i];
            const nome = banco.nmeBanco;
            if (nome.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(banco);
            }
        }
        this.filteredBanco = filtered;
    }

    filterTipoInscricao(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.tipoInscricaoArr.length; i++) {
            let tipoInscricao: TipoInscricao = this.tipoInscricaoArr[i];
            const descricao = tipoInscricao.desTipoInscricao;
            if (descricao.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(tipoInscricao);
            }
        }
        this.filteredTipoInscricao = filtered;
    }

    filterEstado(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.estadosArr.length; i++) {
            let estado: Estado = this.estadosArr[i];
            const uf = estado.uf;
            if (uf.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(estado);
            }
        }
        this.filteredEstado = filtered;
    }

    filterCarteira(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.carteiraArr.length; i++) {
            const carteira = this.carteiraArr[i];
            if (carteira.nmeBanco.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(carteira);
            }
        }
        this.filteredCarteira = filtered;
    }

downloadFile(filename= 'titulos') {
     this.filter.sacado = this.filterSacado;
     this.filter.statusBoleto = this.statusBoletoSel;
     this.filter.banco = this.bancoSel;
     this.filter.carteira = this.carteiraSel;

     this.filter.sacado.desTipoInscricao = this.tipoInscricaoSel.desTipoInscricao;
     this.tipoInscricao = this.tipoInscricaoSel;

     this.filter.sacado.codUfSacado = this.estadoSel.uf;
     this.estado = this.estadoSel;

     this.loading = true;
     this.tituloService.getExportTitulo(this.filter).subscribe((res) => {
        const blob = new Blob([res], { type: 'application/octet-stream' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '_'+ this.datepipe.transform(new Date(), 'yyyy-MM-dd hh:mm a')+ '.xlsx');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
        this.loading = false;
    });
}

exportOptions = [
    {label: 'PDF', icon: 'pi pi-file-pdf', command: (x) => this.exportarConsultaTitulo('PDF') },
    {label: 'XLS', icon: 'pi pi-file-excel', command: (x) => this.exportarConsultaTitulo('XLSX')}
];

exportarConsultaTitulo(formato: string) {
    this.filter.sacado = this.filterSacado;
    this.filter.statusBoleto = this.statusBoletoSel;
    this.filter.banco = this.bancoSel;
    this.filter.carteira = this.carteiraSel;
    this.filter.formatoRelatorio = formato;

    this.filter.sacado.desTipoInscricao = this.tipoInscricaoSel.desTipoInscricao;

    this.filter.sacado.codUfSacado = this.estadoSel.uf;

    this.tituloService.exportarRelatorioTitulos(this.filter).subscribe((res: any) => {
            if (!!res.size && res.size == 3189) {
                this.messageService.add({
                    severity: 'error', summary: 'Error', detail: "Sua pesquisa excedeu a quantidade de registros permitidos, favor refinar os filtros de pesquisas",
                    life: 3000
                });
            } else {
        const file = new Blob([res], {
            type: res.type,

        });
        const url = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Titulos.` + formato;
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
            }
        },
    );
}

/**
 * Compares two Date objects and returns e number value that represents
 * the result:
 * 0 if the two dates are equal.
 * 1 if the first date is greater than second.
 * -1 if the first date is less than second.
 * @param date1 First date object to compare.
 * @param date2 Second date object to compare.
 */
 compareDate(date1: Date, date2: Date) {
    // With Date object we can compare dates them using the >, <, <= or >=.
    // The ==, !=, ===, and !== operators require to use date.getTime(),
    // so we need to create a new instance of Date with 'new Date()'
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // Check if the dates are equal
    const same = d1.getTime() === d2.getTime();
    if (same) {
        return 0;
    }

    // Check if the first is greater than second
    if (d1 > d2) {
         return 1;
    }
    // Check if the first is less than second
    if (d1 < d2) {
        return -1;
    }
 }

 ordenar(field: string, order : number) {
    switch (field) {
       case "bancoResponsavel.nmeBanco":
        if(order == 1) {
            this.titulos = this.titulos.sort((a,b) => (a.bancoResponsavel.nmeBanco < b.bancoResponsavel.nmeBanco ) ? -1 : 1)
        } else if (order) {
            this.titulos = this.titulos.sort((a,b) => (a.bancoResponsavel.nmeBanco > b.bancoResponsavel.nmeBanco ) ? -1 : 1)
        }
        break;
       case "cedente.nmeCedente":
        if(order == 1) {
            this.titulos = this.titulos.sort((a,b) => (a.cedente.nmeCedente < b.cedente.nmeCedente ) ? -1 : 1)
        } else if (order) {
            this.titulos = this.titulos.sort((a,b) => (a.cedente.nmeCedente > b.cedente.nmeCedente ) ? -1 : 1)
        }
        break;
       case "sacado.nmeSacado":
        if(order == 1) {
            this.titulos = this.titulos.sort((a,b) => (a.sacado.nmeSacado < b.sacado.nmeSacado ) ? -1 : 1)
        } else if (order) {
            this.titulos = this.titulos.sort((a,b) => (a.sacado.nmeSacado > b.sacado.nmeSacado ) ? -1 : 1)
        }
        break;
       case "codNossoNumero":
        if(order == 1) {
            this.titulos = this.titulos.sort((a,b) => (a.codNossoNumero < b.codNossoNumero ) ? -1 : 1)
        } else if (order) {
            this.titulos = this.titulos.sort((a,b) => (a.codNossoNumero > b.codNossoNumero ) ? -1 : 1)
        }
        break;
       case "dtaVencimento":
        if(order == 1) {
            this.titulos = this.titulos.sort((a,b) => (a.dtaVencimento < b.dtaVencimento ) ? -1 : 1)
        } else if (order) {
            this.titulos = this.titulos.sort((a,b) => (a.dtaVencimento > b.dtaVencimento ) ? -1 : 1)
        }
        break;
       case "vlrTitulo":
        if(order == 1) {
            this.titulos = this.titulos.sort((a,b) => (a.vlrTitulo < b.vlrTitulo ) ? -1 : 1)
        } else if (order) {
            this.titulos = this.titulos.sort((a,b) => (a.vlrTitulo > b.vlrTitulo ) ? -1 : 1)
        }
        break;
       case "dtaPagamento":
        if(order == 1) {
            this.titulos = this.titulos.sort((a,b) => (a.dtaPagamento < b.dtaPagamento ) ? -1 : 1)
        } else if (order) {
            this.titulos = this.titulos.sort((a,b) => (a.dtaPagamento > b.dtaPagamento ) ? -1 : 1)
        }
        break;
       case "statusBoleto.desStatusBoleto":
        if(order == 1) {
            this.titulos = this.titulos.sort((a,b) => (a.statusBoleto.desStatusBoleto < b.statusBoleto.desStatusBoleto ) ? -1 : 1)
        } else if (order) {
            this.titulos = this.titulos.sort((a,b) => (a.statusBoleto.desStatusBoleto > b.statusBoleto.desStatusBoleto ) ? -1 : 1)
        }
        break;
    }
 }

 async imprimirComprovantesEmLote() {
    this.msgErrorBoolean = false;

    let listaPagamentoDTO = new ListaPagamentoDTO();

    listaPagamentoDTO.pagamentos = [];
    listaPagamentoDTO.pdfUnico = false;

    this.selectedPagamentos.forEach(p => {
        listaPagamentoDTO.pagamentos.push(p.codTitulo);
    });


    if(this.selecaoPdF == 'Unico'){
        listaPagamentoDTO.pdfUnico = true;
    }else{
        listaPagamentoDTO.pdfUnico = false;
    }

        this.emailSacadoService.getPdfLote(listaPagamentoDTO).subscribe((res: any)  => {
                const file = new Blob([res.body], {
                    type: 'application/zip',

                });
                const url = window.URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = url;
                link.download = `comprovantes.zip`;
                link.click();
                window.URL.revokeObjectURL(url);
                link.remove();
                this.fecharBottomSidebarImpressaoComprovantes();
            }, (err) => {
                this.msgErrorBoolean = true;
                console.log(err)
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Falha ao gerar um ou mais comprovantes.'  });
                this.fecharBottomSidebarImpressaoComprovantes();
            });

}

sendEditEmail() {
    this.submitted = false;
    this.emailDialog = true;
}

 async enviarEmailArquivoUnico() {
    console.log("this.selectedPagamentos: ", this.selectedPagamentos)

    let emailSacadoList: EmailSacado[] = [];

    for (const pagamento of this.selectedPagamentos) {
        let emailSacado: EmailSacado = {nmeEmail: null, codSacado: null, codTitulo: null, codCedente: null};
        console.log(emailSacado)
        console.log(pagamento)
        emailSacado.nmeEmail = this.sendEmailInput;
        emailSacado.codSacado = pagamento.sacado.codSacado;
        emailSacado.codTitulo = pagamento.codTitulo;
        emailSacado.codCedente = pagamento.cedente.codCedente;

        emailSacadoList.push(emailSacado);
    }

    this.emailSacadoService.sendEmailList(emailSacadoList).subscribe(
            response => emailSacadoList = response,
            err => console.log(err));
    this.emailDialog = false;
    this.tituloDialog = false;
    this.submitted = false;
    this.sendEmailInput = "";
    this.messageService.add({severity: 'success', summary: 'Successful', detail: this.bscobrancaTranslate.getText('mensagens.titulo-006'), life: 3000});

}

fecharBottomSidebarImpressaoComprovantes() {
    this.bottomSidebarImpressaoComprovantes = false;
    this.selectedPagamentos = new Array(0);
    this.selecaoPdF = undefined;
}

alternarVisualizacaoImpressaoComprovante(){
    this.exibirCheckBoxAprovacao = !this.exibirCheckBoxAprovacao;
    this.fecharBottomSidebarImpressaoComprovantes();
}

checkedListLoteComprovantes() {
    if (this.selectedPagamentos.length > 0) {
        this.totalPagamentosSelecionados = 0;
        this.selectedPagamentos.forEach(pagamento => {
            if (pagamento.statusBoleto.codStatusBoleto === 8 || pagamento.statusBoleto.codStatusBoleto === 3) {
                this.totalPagamentosSelecionados += 1;

            }
        });
        if (this.totalPagamentosSelecionados > 0) {
            this.bottomSidebarImpressaoComprovantes = true;
        }
    } else {
        this.bottomSidebarImpressaoComprovantes = false;
    }
}

}
